import { useEffect } from "react";
import { FormControlLabel } from "@mui/material";
import { CheckBox, Modal } from "@maysoft/common-component-react";

import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import usePost from "../../containers/post/usePost";

import { PublishedNotification } from "../../constants/enums";



const PublishDialog = (props: { open: boolean; postId?: string; onClose?: () => void; onPublishSuccess?: () => void }) => {
    const Strings = useStrings();

    const { publishRequestModel, setPublishRequestModel, handlePublishPost } = usePost();

    useEffect(() => {
        if (!Helpers.isNullOrEmpty(props.postId)) {
            setPublishRequestModel((prev) => ({ ...prev, id: props.postId }));
        }
    }, [props.postId]);

    return (
        <Modal
            maxWidth="sm"
            hasActionButton
            visible={props.open}
            title={Strings.POST.PUBLISH_POST}
            buttonAction={Strings.POST.PUBLISH}
            onClose={props.onClose}
            onAction={() => {
                handlePublishPost({
                    postId: props.postId,
                    onCallBack() {
                        props.onPublishSuccess && props.onPublishSuccess();
                    },
                });
            }}
        >
            <FormControlLabel
                label={Strings.POST.SEND_NOTIFICATION}
                defaultChecked={publishRequestModel?.notification === PublishedNotification.Yes}
                control={
                    <CheckBox
                        checked={publishRequestModel?.notification === PublishedNotification.Yes}
                        onChange={(e) => {
                            const notification = e.target.checked ? PublishedNotification.Yes : PublishedNotification.No;
                            setPublishRequestModel((prev) => ({ ...prev, notification }));
                        }}
                    />
                }
            />
        </Modal>
    );
};

export default PublishDialog;
